module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "article"
  }, [_c('header', {
    staticClass: "article__header"
  }, [_c('h1', {
    staticClass: "article__title",
    class: {
      article__title_margin: _vm.isInfoText, article__title_small: _vm.smallHeader
    }
  }, [_vm._v(_vm._s(_vm.name))])]), (_vm.isInfoText) ? _c('p', {
    staticClass: "article__info"
  }, [_vm._v(_vm._s(_vm.infoText))]) : _vm._e(), _c('main', {
    staticClass: "article__main",
    domProps: {
      "innerHTML": _vm._s(_vm.article)
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5adf0607","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/article/Articlehtml.vue
// module id = 7360e2861d39190a92c4
// module chunks = 0